import {
  CREDIT_MEMO,
  DEBIT_MEMO,
  PARENT,
  WITHHOLDING
} from 'components/pages/finance/NewInvoice/InvoiceTable/TableConstants';

import { toFormattedFinanceBill } from '../../../../../services/financial';

export const getSubGroupAmount = subGroup => {
  return subGroup.reduce((acc, item) => {
    const invoiceAmount = item.invoiceAmount ?? 0;
    if (isParentEventType(item.invoiceType)) {
      return acc + invoiceAmount;
    }
    if (isWithholdingEventType(item.invoiceType)) {
      return acc + invoiceAmount;
    }
    return acc;
  }, 0);
};

export const getSubGroupOpenBalance = subGroup => {
  const hasParentEvents = subGroup.some(item => isParentEventType(item.invoiceType));

  return subGroup.reduce((acc, item) => {
    const paid = item.reconcileTotalAmountPaid ?? 0;
    const clientWithholding = item.clientAmountWithHolding ?? 0;
    const invoiceAmount = item.invoiceAmount ?? 0;

    if (isParentEventType(item.invoiceType)) {
      return acc - paid + clientWithholding;
    }
    if (isWithholdingEventType(item.invoiceType)) {
      return acc - paid + invoiceAmount;
    }
    if (isAdjustmentEventType(item.invoiceType) && !hasParentEvents) {
      return acc - paid + invoiceAmount;
    }
    return acc;
  }, 0);
};

export const getGroupLength = (group, invoiceType) => {
  const subGroupLength = group
    .filter(item => item.typeSubHeader)
    .filter(item => {
      if (!isAdjustmentPDF(invoiceType)) {
        return !isAdjustmentEventType(item.invoiceType);
      }
      return true;
    }).length;
  if (subGroupLength) {
    return subGroupLength;
  } else {
    return group.filter(item => {
      if (!isAdjustmentPDF(invoiceType)) {
        return !isAdjustmentEventType(item.invoiceType);
      }
      return true;
    }).length;
  }
};

export const getGroupAmount = group => {
  const subGroupsPresent = group.filter(item => item.typeSubHeader);
  if (subGroupsPresent.length) {
    return subGroupsPresent.reduce((acc, item) => acc + item.subGroupAmount, 0);
  } else {
    return null;
  }
};

export const getGroupOpenBalance = group => {
  const expenses = group.filter(item => ['EXPENSE_FIXED', 'EXPENSE_VARIABLE'].includes(item.eventType));

  if (expenses.length && expenses.length === group.length) {
    return group.reduce((acc, item) => acc + item.openBalance, 0);
  }

  const subGroups = group.filter(item => item.typeSubHeader);
  return subGroups.reduce((acc, item) => acc + item.subGroupOpenBalance, 0);
};

export const getGroupTotalAmountString = item => {
  return toFormattedFinanceBill(item.groupAmount ? item.groupAmount : item.amountForItem * item.groupLength);
};

export const isAdjustmentEventType = invoiceType => {
  return [CREDIT_MEMO, DEBIT_MEMO].includes(invoiceType);
};

export const isParentEventType = invoiceType => {
  return PARENT === invoiceType;
};

export const isWithholdingEventType = invoiceType => {
  return WITHHOLDING === invoiceType;
};

export const isExpenseEventType = invoiceType => {
  return ['Expense - Fixed', 'Expense - Variable'].includes(invoiceType);
};

export const isParentPDF = invoiceType => {
  return PARENT === invoiceType;
};

export const isWithholdingPDF = invoiceType => {
  return WITHHOLDING === invoiceType;
};

export const isAdjustmentPDF = invoiceType => {
  return [CREDIT_MEMO, DEBIT_MEMO].includes(invoiceType);
};
